/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Refused_UploadInputs */



/**
* | output |
* | --- |
* | "Uploading images isn't available in the demo." |
*
* @param {Demo_Refused_UploadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const demo_refused_upload = /** @type {((inputs?: Demo_Refused_UploadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Refused_UploadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка изображений в демо недоступна.")
	return /** @type {LocalizedString} */ ("Uploading images isn't available in the demo.")
});